module.exports = __webpack_public_path__ + "static/media/evans.54b844ff.jpg";